import { isWeb } from '@savvy/deprecated-shared/utils/platform/is-web';

/**
 * The browser's IANA time zone for the login detect-and-set seed, or `undefined` when it can't be
 * determined.
 *
 * Web-only by design: returns `undefined` on native so the mobile app never seeds a zone. Seeding is
 * a web-only concern (mobile advisors stay on the server's Eastern fallback until they pick one), and
 * `XLogin` is shared with the React Native app, so the platform gate lives here rather than at the
 * shared login internals. Never throws - a missing/broken `Intl` just omits the field and login
 * proceeds unchanged.
 */
export function detectBrowserTimeZone(): string | undefined {
  if (!isWeb()) {
    return undefined;
  }
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}

/**
 * The partial login-request payload carrying the detected zone: `{ time_zone }` on web when a zone is
 * detected, or `{}` otherwise (so the field is omitted rather than sent as `undefined`). Keeps the
 * `time_zone` key and omit-when-absent contract in one place, shared by both login factor forms.
 */
export function detectedTimeZonePayload(): { time_zone?: string } {
  const timeZone = detectBrowserTimeZone();
  return timeZone ? { time_zone: timeZone } : {};
}
